export default __webpack_public_path__ + "static/media/icon-logo.71d45f0f.svg";